<script>
import { defineComponent, onMounted, onUnmounted } from 'vue'
import { error as errorFunc, success } from '@/utils'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'SocialHandler',
  setup: function () {
    const store = useStore()
    const { t } = useI18n()

    const handleMessage = (event) => {
      store.dispatch('social/receiveMessage', event)
        .then(data => {
          if (!data?.error) {
            success()
          }
          else if (data?.showError) {
            errorFunc(data.message || t('components.socialHandler.error'))
          }
        })
        .catch(() => {
          errorFunc(t('components.socialHandler.error'))
        })
    }

    onMounted(() => {
      window.addEventListener('message', handleMessage, false)
    })

    onUnmounted(() => {
      window.removeEventListener('message', handleMessage)
    })

    return {}
  }
})
</script>

<template>
  <template />
</template>
